import { pathOr } from 'ramda';

import { PAGE_SUCCESS } from 'store/app/types';

import { types } from './actions';
import { MODES } from './constants';

const initialState = {
  allowCreateAccount: false,
  contact: null,
  contactId: null,
  isLoading: false,
  includeAccountSelect: false,
  isOpen: false,
  isSaving: false,
  mode: MODES.CREATE,
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case PAGE_SUCCESS:
      return {
        ...initialState,
      };
    case types.CLOSE:
      return {
        ...initialState,
      };
    case types.SET_CONTACT:
      return {
        ...state,
        contact: payload.contact,
      };
    case types.OPEN_ERROR:
      return {
        ...state,
        isLoading: false,
        isOpen: false,
      };
    case types.OPEN_REQUEST:
      return {
        ...state,
        allowCreateAccount: pathOr(false, ['allowCreateAccount'], payload),
        contactId: pathOr(null, ['contactId'], payload),
        includeAccountSelect: pathOr(false, ['includeAccountSelect'], payload),
        isLoading: true,
        isOpen: true,
        mode: pathOr(MODES.CREATE, ['mode'], payload),
      };
    case types.OPEN_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case types.SAVE_ERROR:
      return {
        ...state,
        isSaving: false,
      };
    case types.SAVE_REQUEST:
      return {
        ...state,
        isSaving: true,
      };
    case types.SAVE_SUCCESS:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.common.drawers.contactDrawer;

export const getAllowCreateAccount = (state) =>
  getScope(state).allowCreateAccount;

export const getContact = (state) => getScope(state).contact;

export const getContactId = (state) => getScope(state).contactId;

export const getIncludeAccountSelect = (state) =>
  getScope(state).includeAccountSelect;

export const getIsLoading = (state) => getScope(state).isLoading;

export const getIsOpen = (state) => getScope(state).isOpen;

export const getIsSaving = (state) => getScope(state).isSaving;

export const getMode = (state) => getScope(state).mode;
